import 'parsleyjs';
import { overrideParsleyJS } from './parsleyjs.overrides';

(() => {
  // Bind parsleyjs to necessary elements.
  ($('[data-parsley-validate]') as any).parsley();
  // Override default behaviour of parsleyjs.
  overrideParsleyJS();
})();
